/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/KeyboardManager',['CardUI/KeyboardNavigator'], function (KeyboardNavigator) {
	"use strict";

	var KeyboardManager = {

		_ctrlDown: false,

		_ui: null,

		_anyKeyHandler: null,

		initialize: function (ui) {
			this._ui = ui;
			window.addEventListener('keydown', this.handleKeyDown.bind(this), true);
			window.addEventListener('keypress', this.handleKeyPress.bind(this), true);
			window.addEventListener('mousewheel', this.handleMouseWheel.bind(this), true);
		},

		handleKeyDown: function (event) {
			var handled = true;

			if (typeof this._anyKeyHandler == 'function') {
				handled = this._anyKeyHandler(event);
			} else {
				var key, command = this.getCommandFromKeyboardEvent(event);

				if (command == 'Tab' && event.shiftKey) {
					command = "ShiftTab";
				}

				if (command === 'Activate' && (event.altKey || this._altDown)) {
					command = 'FullScreen';
					this._altDown = false;
				} else if (command === 'Alt') {
					this._altDown = true;
					return;
				} else if (command === 'Z' && (event.ctrlKey || this._ctrlDown)) {
					command = 'Undo';
				} else if (command === 'Ctrl') {
					this._ctrlDown = true;
					return;
				} else if (typeof command === 'undefined') {
					return;
				}

				this._ui.handleCommand(command);
			}
			if (handled) {
				event.preventDefault();
			}
		},

		handleKeyPress: function (event) {

			if (typeof this._anyKeyPressHandler == 'function') {
				var handled = this._anyKeyPressHandler(event);

				if (handled) {
					event.preventDefault();
				}
			}
		},

		handleMouseWheel: function (event) {

			var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail))),
				command = 'Tab';

			if (delta < 0) {
				command = 'ShiftTab';
			}

			this._ui.handleCommand(command, true);

		},

		getCommandFromKeyboardEvent: function (event) {
			var code = 0;
			if (event.which == null) {
				code = event.keyCode; // IE
			} else if (event.which != 0) {
				code = event.which;   // the rest
			}
			return KeyboardNavigator.KeyPressCharMap[code.toString()];
		},

		setAnyKeyHandler: function (callback) {
			this._anyKeyHandler = callback;
		},

		removeAnyKeyHandler: function () {
			this._anyKeyHandler = null;
		},

		setAnyKeyPressHandler: function (callback) {
			this._anyKeyPressHandler = callback;
		},

		removeAnyKeyPressHandler: function () {
			this._anyKeyPressHandler = null;
		}
	};


	return KeyboardManager;

});

